import { endpoints } from "config/endpoints.config"
import { IGenericModel, generic } from "models/generic"
import { IWalletTransaction } from "./wallet"

export const adminWallets: IGenericModel<IWalletTransaction> = {
    ...generic(endpoints.WALLET_TRANSACTIONS_ADMIN),
}
